import { Pipe, PipeTransform } from '@angular/core';
import { FileInfo } from '@progress/kendo-angular-upload';

@Pipe({
  name: 'fileGroupClass',
})
export class FileGroupClassPipe implements PipeTransform {
  transform(file: FileInfo): { [klass: string]: boolean } | string {
    return getFileGroupCssClass(file.extension ?? '');
  }
}
const getFileGroupCssClass = fileExtension => {
  const initial = 'file';
  for (const group in fileGroupMap) {
    if (fileGroupMap[group].indexOf(fileExtension) >= 0) {
      if (group === 'discImage') {
        return `${initial}-disc-image`;
      }
      return `${initial}-${group}`;
    }
  }
  return initial;
};
const fileGroupMap = {
  audio: ['.aif', '.iff', '.m3u', '.m4a', '.mid', '.mp3', '.mpa', '.wav', '.wma', '.ogg', '.wav', '.wma', '.wpl'],
  video: [
    '.3g2',
    '.3gp',
    '.avi',
    '.asf',
    '.flv',
    '.m4u',
    '.rm',
    '.h264',
    '.m4v',
    '.mkv',
    '.mov',
    '.mp4',
    '.mpg',
    '.rm',
    '.swf',
    '.vob',
    '.wmv',
  ],
  image: [
    '.ai',
    '.dds',
    '.heic',
    '.jpe',
    'jfif',
    '.jif',
    '.jp2',
    '.jps',
    '.eps',
    '.bmp',
    '.gif',
    '.jpeg',
    '.jpg',
    '.png',
    '.ps',
    '.psd',
    '.svg',
    '.svgz',
    '.tif',
    '.tiff',
  ],
  txt: ['.doc', '.docx', '.log', '.pages', '.tex', '.wpd', '.wps', '.odt', '.rtf', '.text', '.txt', '.wks'],
  presentation: ['.key', '.odp', '.pps', '.ppt', '.pptx'],
  data: ['.xlr', '.xls', '.xlsx'],
  programming: [
    '.tmp',
    '.bak',
    '.msi',
    '.cab',
    '.cpl',
    '.cur',
    '.dll',
    '.dmp',
    '.drv',
    '.icns',
    '.ico',
    '.link',
    '.sys',
    '.cfg',
    '.ini',
    '.asp',
    '.aspx',
    '.cer',
    '.csr',
    '.css',
    '.dcr',
    '.htm',
    '.html',
    '.js',
    '.php',
    '.rss',
    '.xhtml',
  ],
  pdf: ['.pdf'],
  config: ['.apk', '.app', '.bat', '.cgi', '.com', '.exe', '.gadget', '.jar', '.wsf'],
  zip: ['.7z', '.cbr', '.gz', '.sitx', '.arj', '.deb', '.pkg', '.rar', '.rpm', '.tar.gz', '.z', '.zip', '.zipx'],
  discImage: ['.dmg', '.iso', '.toast', '.vcd', '.bin', '.cue', '.mdf'],
};
